// This import loads the firebase namespace along with all its type information.
import MobileLoginProxy from './mobile-login-proxy-model'

export async function load_mobileLoginProxys(): Promise<MobileLoginProxy[]> {
  throw 'Not implemented'
}

export async function delete_mobileLoginProxy(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mobileLoginProxy(): Promise<MobileLoginProxy> {
  throw 'Not implemented'
}
